import { ApdmCampaignDefinition, ApdmCampaignVersionRef } from './campaign';

export enum ApdmCampaignWizardStep {
  Basics = 'basics',
  Audience = 'audience',
  Content = 'content',
  Schedule = 'schedule',
}

export type ApdmCampaignWizardStepInput = ApdmCampaignVersionRef &
  (
    | {
        step: ApdmCampaignWizardStep.Basics;
        data: Pick<ApdmCampaignDefinition, 'title' | 'kind' | 'mode'>;
      }
    | {
        step: ApdmCampaignWizardStep.Audience;
        data: ApdmCampaignDefinition['audience'];
      }
    | {
        step: ApdmCampaignWizardStep.Content;
        data: Pick<
          ApdmCampaignDefinition,
          | 'content'
          | 'couponCampaignId'
          | 'posterTemplateAttachmentId'
          | 'variants'
        >;
      }
    | {
        step: ApdmCampaignWizardStep.Schedule;
        data: Pick<
          ApdmCampaignDefinition,
          'schedule' | 'policy' | 'reviewEnabled'
        >;
      }
  );
